export type TimelinePoint = {
  /** The bucket's first day, YYYY-MM-DD in UTC. */
  date: string;
  impressions: number;
  responses: number;
  score: number | null;
};

type FillTimelineParams = { points: readonly TimelinePoint[]; interval: 'day' | 'week' };

const DAY_MS = 86_400_000;

/** Bounds a long life to its most recent buckets, which a chart can still draw a bar each for. */
const MAX_BUCKETS = 400;

/**
 * Every bucket from the first to the last, with zeros where the server returned
 * none, so a quiet day reads as zero instead of the line skipping it. Dates are
 * walked in UTC, the zone the server buckets in. Pure, for its test.
 */
export function fillTimeline({ points, interval }: FillTimelineParams): TimelinePoint[] {
  const first = points[0];
  const last = points[points.length - 1];
  if (!first || !last) return [];

  const step = interval === 'week' ? 7 * DAY_MS : DAY_MS;
  const byDate = new Map(points.map((point) => [point.date, point]));
  const filled: TimelinePoint[] = [];
  const end = Date.parse(`${last.date}T00:00:00Z`);
  // Counted back from the end, so a long-lived survey keeps its recent history.
  const start = Math.max(Date.parse(`${first.date}T00:00:00Z`), end - (MAX_BUCKETS - 1) * step);

  for (let at = start; at <= end; at += step) {
    const date = new Date(at).toISOString().slice(0, 10);
    filled.push(byDate.get(date) ?? { date, impressions: 0, responses: 0, score: null });
  }
  return filled;
}
